<script>
  export let color="white";
</script>

<svg height='15px' width='15px' version="1.1" style="fill:{color};margin:0 0 -1px 0;" viewBox="28 21 48 48" xmlns="http://www.w3.org/2000/svg">
 <path d="m44 31v13h-13v12h13v13h12v-13h13v-12h-13v-13z"/>
</svg>

